import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import config from "../config";
import { getStorage } from "firebase/storage";

// Your Firebase config (Replace with your actual Firebase credentials)
const firebaseConfig = {
    apiKey: config.firebase.api_key,
    authDomain: config.firebase.auth_domain,
    projectId: config.firebase.project_id,
    storageBucket: config.firebase.storage_bucket,
    messagingSenderId: config.firebase.messaging_sender_id,
    appId: config.firebase.app_id,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

const storage = getStorage(app);
export {storage};